import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'insurances_hub';
export const route = 'insurances_hub/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/InsurancesPage').then(({
  InsurancesPageHub
}) => ({
  default: InsurancesPageHub
}))));